/* tslint:disable */

declare var Object: any;
export interface StorageActualInterface {
  "id"?: number;
}

export class StorageActual implements StorageActualInterface {
  "id": number;
  constructor(data?: StorageActualInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `StorageActual`.
   */
  public static getModelName() {
    return "StorageActual";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of StorageActual for dynamic purposes.
  **/
  public static factory(data: StorageActualInterface): StorageActual{
    return new StorageActual(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'StorageActual',
      plural: 'StorageActuals',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk-budget/models/StorageActual.ts